import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRouter } from "next/router";
import CtaButtonGroup, { CtaType } from "../molecules/CtaButtonGroup";

export type FeatureSectionPropsType = {  
  title: string;
  features: string[];
  cta?: CtaType;
};

const FeatureSection = ({ title, features, cta }: FeatureSectionPropsType) => {
  const router = useRouter();
  const isPricingPage = router.pathname === "/pricing";
  return (
    <div className="container max-w-7xl mx-auto">
      <div className=" mb-12 text-center text-title-32  md:mb-16 ">{title}</div>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
        {features.map((feature) => {
          return (
            <div key={feature} className="flex w-full items-start gap-4">
              <div className="h-5 w-5 flex items-center justify-center">
                {isPricingPage ? (
                  <FontAwesomeIcon icon={faCheck} style={{ color: "#269A5A" }} className="w-[20px] h-[20px]" />
                ) : (
                  <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3.7578 12.9461C2.13062 11.3189 2.13062 8.68074 3.7578 7.05356L7.05363 3.75774C8.68081 2.13055 11.319 2.13055 12.9462 3.75773L16.242 7.05356C17.8692 8.68074 17.8692 11.3189 16.242 12.9461L12.9462 16.2419C11.319 17.8691 8.68081 17.8691 7.05363 16.2419L3.7578 12.9461Z"
                    stroke="#6059FF"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.0939 8.92236L9.47696 11.5393L7.90381 9.97113"
                    stroke="#6059FF"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                )}
              </div>
              <span className="font-inter font-medium text-[16px] text-[#4A4A4A]">{feature}</span>
            </div>
          );
        })}
      </div>
      {cta && (
        <div className="flex justify-center mt-8">
          <div className="w-[240px]">
            <CtaButtonGroup ctas={[cta]} fullWidth />
          </div>
        </div>
      )}
    </div>
  );
};

export default FeatureSection;
